import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { IconModule } from 'src/app/icon/icon.module';
import { MaterialModule } from 'src/app/material.module';
import { ConflictResolution } from 'src/app/services/document.service';
import { IDocumentConflictDialog } from 'src/app/shared/interfaces/IDocument';

@Component({
  standalone: true,
  selector: 'app-document-conflict-dialog',
  templateUrl: './document-conflict-dialog.component.html',
  styleUrl: './document-conflict-dialog.component.scss',
  imports: [MaterialModule, TranslateModule, IconModule],
})
export class DocumentConflictDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DocumentConflictDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public config: IDocumentConflictDialog
  ) {}

  onCancel() {
    this.dialogRef.close();
  }

  onResolve(resolution: ConflictResolution) {
    this.dialogRef.close(resolution);
  }
}
